<template>
    <div class="height100">
      <van-uploader
	  class="mt-3"
	  :max-size="3 * 1024 * 1024"
	  :before-read="beforeRead"
	  @oversize="onOversize"
    multiple
     v-model="picurllist"
     :max-count="6"
     :before-delete="picurlDelete"
	>
	  <!-- <van-button icon="manager-o" size="small" type="primary">更换头像</van-button> -->
	</van-uploader>

  <!-- <van-uploader v-model="fileList" multiple /> -->

  <!-- 剪裁图片组件 -->
    <van-popup
      class="bg-tran"
      v-model="showCropper"
      closeable
      position="top"
      :style="{ height: '100%' }"
    >
      <div class="flex-column-center height100">
        <app-VueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :full="option.full"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedBox="option.fixedBox"
          :high="option.high"
          :mode="option.mode"
        ></app-VueCropper>
        <div class="popup_bottom">
          <div class="bottom_item"><span @click="cancelCropper">取消</span></div>
          <div class="bottom_item"><span @click="rotateImage" class="font18"><van-icon name="replay" /></span></div>
          <div class="bottom_item"><span @click="getCropBlob">确定</span></div>
        </div>
      </div>
    </van-popup>
    </div>
</template>

<script>

import { VueCropper } from 'vue-cropper'
export default {
	data() {
		return {
      picurl:[],
          picurllist:[],
			    showCropper: false, // 截图弹窗遮罩默认隐藏
	      	imageAccept: "/jpg,/png,/jpeg",
          imageFileName: '',
          option: {
		        img: '',
		        outputSize: 0.8,
		        info: false, // 裁剪框的大小信息
		        outputType: 'jpeg', // 裁剪生成图片的格式
		        canScale: false, // 图片是否允许滚轮缩放
		        autoCrop: true, // 是否默认生成截图框
		        autoCropWidth: window.innerWidth - 100 + 'px', // 默认生成截图框宽度
		        autoCropHeight: window.innerWidth - 100 + 'px', // 默认生成截图框高度
		        high: true, // 是否按照设备的dpr 输出等比例图片
		        fixedBox: true, // 固定截图框大小 不允许改变
		        fixed: true, // 是否开启截图框宽高固定比例
		        fixedNumber: [1, 1], // 截图框的宽高比例
		        full: true, // 是否输出原图比例的截图
		        canMoveBox: false, // 截图框能否拖动
		        original: false, // 上传图片按照原始比例渲染
		        centerBox: false, // 截图框是否被限制在图片里面
		        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
		        mode: '100% auto' // 图片默认渲染方式
		     },
		}
  },

  components: {
      'app-VueCropper':VueCropper,
  },

	methods: {
		// 上传文件过大
		onOversize() {
		  this.$toast('图片不能大于3M');
		},

		// 获取文件后缀
		getFileSuffix(fileName) {
		  return fileName.match(/\/\w+$/)[0].toLowerCase();
		},

		// 选择图片上传前操作，调起剪裁组件
		beforeRead(file) {
      console.log(file);
		  if (!this.imageAccept.includes(this.getFileSuffix(file.type))) {
		    return this.$toast('请上传 jpg/png 格式图片');
		  }
		  this.showCropper = true;
		  this.imageFileName = file.name;
		  // 本地图片转成base64，用于截图框显示本地图片
		  this.imageToBase64(file);
    },
    // 将本地图片转化为Base64，否则vue-cropper组件显示不出要本地需要剪裁的图片
	    imageToBase64(file) {
	      let reader = new FileReader();
	      reader.readAsDataURL(file);
	      reader.onload = () => {
	        // 截图框中的图片
	        this.option.img = reader.result;
	      }
	      reader.onerror = function (error) {
	        console.log('Error: ', error)
	      }
	    },

	    // 确认剪裁并上传图片
	    async getCropBlob() {
	      // this.$toast('上传中', 0);
	      let formData = new FormData();
	      this.$refs.cropper.getCropData((data) => {
            // console.log(data);
             var that = this
             that.$api.post("/Upload/uploadcord",{'file':data}).then(res => {
               console.log(res);
                 if(res.code==1){
                    this.showCropper = false;
                     // file.status = 'done';
                     // file.message = res.data;
                     // file.content = res.data;
                     console.log(res.data);
                     // that.yyzz =[{url: res.user.yyzz}];
                     this.picurllist.push({url: res.data});
                     console.log(this.picurllist);
                 }else{
                   setTimeout(() => {
                     file.status = 'failed';
                     file.message = '上传失败';
                   }, 1000);
                 }
             })




	        // 上传图片至服务器
	        // changeAvatar(formData)
	        // .then(res => {
	        //   if(res.code === 200){
	        //     this.$toast('更改头像成功');
	        //   } else {
	        //     this.$toast('上传失败');
	        //   }
	        // })
	        // .catch(err => console.error(err));
	      })
	    },

	    // 旋转图片
	    rotateImage() {
	      this.$refs.cropper.rotateRight();
	    },

	    // 取消截图上传头像
	    cancelCropper() {
	      this.showCropper = false; // 隐藏切图遮罩
	      this.showPopup = true;
	    },


      // 图片删除方法
       deleteimg(imgurl){
         var that=this;
         this.isloadImg = true;
         that.$api.get("/Upload/imgdelete",{'imgurl':imgurl}).then(res => {
             // console.log(res);
             Toast(res.msg);
         });
       },

      // 删除图片
      picurlDelete(file) {
        console.log(file);
          var that = this;
          var imgurl = file.url;   // 删除的数据
         const findThisNum = that.picurllist.findIndex(x => x === imgurl )
         console.log(imgurl)
         that.picurllist.splice(findThisNum, 1)

          that.deleteimg(imgurl);
          return new Promise((resolve, reject) => {
            console.log("删除文件的回调,afterDelete");
            this.isloadImg = false;
            resolve();
          });
      },

	}
}
</script>



// WEBPACK FOOTER //
// src/components/cj.vue